import { useState } from "react";
import { motion } from "framer-motion";
import Logo from "../../img/Logotipo.webp";
import Tecko from "../../img/LogoTransparent.webp";
import { PageModal, TermsModal } from "../Utils/CustomStyles";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { HORARIOS_TEXTO } from "../Utils/horariosSucursal";

const Footer = () => {
  const [mostrarModal, setMostrarModal] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <footer className="relative overflow-hidden bg-gradient-to-b from-white to-gray-100 backdrop-blur-md border-t border-gray-300 text-gray-700 font-[Sawarabi_Mincho]">
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-12 md:py-14">
        <motion.img
          src={Logo}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-[420px] h-[420px] mx-auto my-auto opacity-10 object-contain select-none pointer-events-none"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 0.12 }}
          transition={{ duration: 1.5 }}
        />

        <div className="relative grid grid-cols-1 md:grid-cols-3 md:items-start gap-10 md:gap-8">
          {/* Marca */}
          <motion.div
            className="flex flex-col items-center md:items-start text-center md:text-left"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45 }}
          >
            <motion.img
              src={Logo}
              alt="390gramosymassabor"
              className="w-36 h-36 md:w-40 md:h-40 object-contain drop-shadow-lg"
              whileHover={{ scale: 1.04 }}
              transition={{ type: "spring", stiffness: 200 }}
            />
          </motion.div>

          {/* Contacto + horario */}
          <motion.div
            className="flex flex-col items-center md:items-start text-center md:text-left"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1, duration: 0.45 }}
          >
            <h3 className="text-xl font-semibold text-gray-800 border-b-2 border-yellow-500 pb-1 mb-4 inline-block">
              Contacto
            </h3>
            <div className="space-y-2 text-base md:text-lg text-gray-700">
              <p>📍 Vargas, Venezuela</p>
              <p>📞 +58 412 290 5789</p>
              <div className="pt-1 space-y-3">
                <span className="block text-sm uppercase tracking-wide text-gray-500 mb-0.5">
                  Horarios por sucursal
                </span>
                {[HORARIOS_TEXTO.caraballeda, HORARIOS_TEXTO.maiquetia].map(
                  (sucursal) => (
                    <div key={sucursal.nombre}>
                      <span className="font-semibold text-gray-800 block text-sm">
                        {sucursal.nombre}
                      </span>
                      {sucursal.lineas.map((linea) => (
                        <span
                          key={linea}
                          className="text-gray-700 block text-sm leading-snug"
                        >
                          {linea}
                        </span>
                      ))}
                    </div>
                  )
                )}
              </div>
            </div>
          </motion.div>

          {/* Redes + términos */}
          <motion.div
            className="flex flex-col items-center md:items-end text-center md:text-right"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.45 }}
          >
            <h3 className="text-xl font-semibold text-gray-800 border-b-2 border-yellow-500 pb-1 mb-4 inline-block">
              Síguenos
            </h3>
            <div className="flex gap-5 justify-center md:justify-end mb-6">
              <motion.a
                href="https://www.instagram.com/390gramosymassabor"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                whileHover={{ scale: 1.12 }}
                whileTap={{ scale: 0.96 }}
              >
                <FaInstagram className="w-8 h-8 text-yellow-600 hover:text-yellow-700 transition-colors" />
              </motion.a>
              <motion.a
                href="https://wa.me/584122905789"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                whileHover={{ scale: 1.12 }}
                whileTap={{ scale: 0.96 }}
              >
                <FaWhatsapp className="w-8 h-8 text-yellow-600 hover:text-yellow-700 transition-colors" />
              </motion.a>
            </div>
            <button
              type="button"
              onClick={() => setShowTerms(true)}
              className="text-sm text-gray-600 hover:text-yellow-600 transition underline underline-offset-2"
            >
              Términos y Condiciones
            </button>
          </motion.div>
        </div>
      </div>

      <div className="relative z-10 border-t border-gray-300 bg-white/70 backdrop-blur-sm pt-5 pb-4 text-center text-sm text-gray-600">
        <motion.div
          className="flex flex-col sm:flex-row items-center justify-center gap-2 mb-2 px-4"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span>
            © {new Date().getFullYear()}{" "}
            <span className="font-semibold text-gray-800">390gramosymassabor</span>.
            Todos los derechos reservados.
          </span>
        </motion.div>

        <motion.div
          className="mt-2 flex flex-col items-center gap-1"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          <img
            src={Tecko}
            alt="Teckologys Logo"
            className="w-14 h-14 object-contain drop-shadow-md"
          />
          <span className="text-xs text-gray-500 uppercase tracking-widest">
            Desarrollado por <strong>Teckologys</strong>
          </span>
        </motion.div>
      </div>

      <PageModal mostrarModal={mostrarModal} onComplete={() => setMostrarModal(false)} />
      <TermsModal isOpen={showTerms} onClose={() => setShowTerms(false)} />
    </footer>
  );
};

export default Footer;
